<template>
    <v-dialog v-model="dialogEdit" persistent max-width="75%">
        <v-card v-if="showDelete">
            <v-card-title class="headline justify-space-between">
                Подтверждение удаления
            </v-card-title>
            <v-card-text>
                Вы действительно хотите удалить этот элемент? <br/>
                Это действие необратимо!
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" @click="deleteItem">Да, я хочу удалить</v-btn>
                <v-btn color="error" class="v-btn--save" @click="showDelete = false">Отменить</v-btn>
            </v-card-actions>
        </v-card>
        <v-card class="v-card--dialog" v-else>
            <v-card-title class="headline justify-space-between">
                Добавить новый текстовый блок
                <v-btn color="error" class="v-btn--save" @click="showDelete = true">Удалить</v-btn>
            </v-card-title>
            <v-card-text>
                <v-form>
                    <v-layout flex wrap>
                        <v-flex xs4>
                            <upload-img :image-width="445" :image-height="582" v-model="textBlock.img"
                                        :content-area="12">
                                <div slot="activator">
                                    <v-avatar size="100%" v-ripple tile
                                              v-if="typeof textBlock.img === 'object' && textBlock.img.imageURL">
                                        <img :src="textBlock.img.imageURL" alt=""/>
                                    </v-avatar>
                                    <v-avatar size="100%" v-ripple tile
                                              v-else-if="typeof textBlock.img === 'string' && textBlock.img !== ''">
                                        <img :src="rootURL + textBlock.img" alt=""/>
                                    </v-avatar>
                                    <v-avatar size="100%" v-ripple tile class="grey lighten-3" v-else>
                                        <img src="/static/img/media/text_block_blank.svg" alt=""/>
                                    </v-avatar>
                                </div>
                            </upload-img>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs7>
                            <v-subheader class="pa-0">Название</v-subheader>
                            <v-text-field
                                ref="textBlock_title"
                                v-model="textBlock.title"
                                v-validate="'required|max:255'"
                                data-vv-name="title"
                                :error-messages="errors.collect('title')"
                                single-line
                                text
                                solo
                                required/>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-switch v-model="textBlock.status"
                                      :label="`${textBlock.status ? 'Активен' : 'Не активен' }`"/>
                            <v-subheader class="pa-0">Описание</v-subheader>
                            <v-textarea
                                ref="textBlock_text"
                                v-model="textBlock.text"
                                v-validate="'required|max:255'"
                                data-vv-name="text"
                                :error-messages="errors.collect('text')"
                                text
                                solo
                                required
                                counter="255"/>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="save">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
                <v-btn color="error" class="v-btn--save" @click.native="onClose">Отмена</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import config from '../../../config'
    import UploadImg from '../../../components/Media/Upload'
    import TextBlockAPI from '../../../api/textblock'

    export default {
        name: 'editTextBlock',
        components: { UploadImg },
        $_veeValidate: {
            validator: 'new'
        },
        props: ['dialogEdit', 'onClose', 'textBlock'],
        data: () => ({
            loading: false,
            showDelete: false,
            rootURL: '',
            dictionary: {
                custom: {
                    title: {
                        required: 'Введите тайтл для слайдера',
                        max: 'Превышено максимальное количество символов'
                    },
                    text: {
                        required: 'Описание не заполнено',
                        max: 'Превышено максимальное количество символов'
                    }
                }
            }
        }),
        created () {
            this.rootURL = config.rootPath
        },
        mounted () {
            this.$validator.localize('ru', this.dictionary)
        },
        watch: {
            dialogEdit (value) {
                if (!value) this.onClose()
            }
        },
        methods: {
            save () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true
                        TextBlockAPI
                            .edit(this.textBlock)
                            .then(response => {
                                this.$store.commit('showSnackbar', {
                                    text: response.data.data,
                                    color: 'success'
                                })
                                this.onClose()
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            },
            deleteItem () {
                TextBlockAPI
                    .delete(this.textBlock.id)
                    .then(response => {
                        this.$store.commit('showSnackbar', { text: response.data.data[Object.keys(response.data.data)[0]][0] })
                        this.onClose()
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
            }
        }
    }
</script>
